import { type FileCategory } from "@/types";
import isImageFile from "@/helpers/files/isImageFile";
import isPDFFile from "@/helpers/files/isPDFFile";

export default (file: File): FileCategory => {
  if (isImageFile(file)) {
    return "image";
  }

  if (isPDFFile(file)) {
    return "pdf";
  }

  return "document";
};
